import React from "react";
import ReactDOM from "react-dom";
import { Form } from "./quiz";

function App() {
  return <Form />;
}

ReactDOM.render(<App />, document.getElementById("quiz-app"));
